import React from 'react';
import { observer } from 'mobx-react';
import { SvgLoader, SvgProxy } from 'react-svgmt';
import { rgba } from 'polished';
import { toValidColor } from '@awarego-ui/components/utils/helpers';

function ThemedEmailSentSVG({ primaryColor }) {
    const validColor = toValidColor(primaryColor);
    return (
        <SvgLoader path="/static/img/assessment/quiz-demo.svg">
            <SvgProxy selector="#primary" fill={validColor} />
            <SvgProxy selector="#secondary" fill={rgba(validColor, 0.1)} />
        </SvgLoader>
    );
}

export default observer(ThemedEmailSentSVG);
